<template src="./ErrorPage.html"></template>
<script lang="js">
import Vue from 'vue';
import axios from "axios";
import {AnalyzeIdentifier} from '../../plugins/analyzeIdentifier';
import ErrorType from '../../enums/error-types';

export default Vue.extend({
  name: 'nmouc-error-page',
  computed: {
    analyzeIdentifier: function () {
      if (this.$store.state.error === ErrorType.RETRY_LATER_UI) {
        return AnalyzeIdentifier.ID + ' (UI)';
      } else if (this.$store.state.error === ErrorType.NO_VIN)  {
        return AnalyzeIdentifier.ID + ' (' + ErrorType.NO_VIN + ')';
      } else if (this.$store.state.error === ErrorType.NO_BASEURL)  {
        return AnalyzeIdentifier.ID + ' (' + ErrorType.NO_BASEURL + ')';
      } else if (this.$store.state.error === ErrorType.NO_JWE)  {
        return AnalyzeIdentifier.ID + ' (' + ErrorType.NO_JWE + ')';
      } else if (this.$store.state.error === ErrorType.NO_CONTEXT)  {
        return AnalyzeIdentifier.ID + ' (' + ErrorType.NO_CONTEXT + ')';
      } else if (this.$store.state.error === ErrorType.NO_COMPANYID)  {
        return AnalyzeIdentifier.ID + ' (' + ErrorType.NO_COMPANYID + ')';
      } else {
        return AnalyzeIdentifier.ID;
      }
    },
    isError: function () {
      return this.$store.state.error !== ErrorType.MAINTENANCE
    },
    isFatalError: function () {
      return (this.$store.state.error === ErrorType.RETRY_LATER ||
          this.$store.state.error === ErrorType.RETRY_LATER_NEW_VEHICLE ||
          this.$store.state.error === ErrorType.RETRY_LATER_UI)
        && !this.isTetheringError;
    },
    isServiceError: function () {
      return (this.$store.state.error === ErrorType.CONTACT_SERVICE_PARTNER ||
          this.$store.state.error === ErrorType.NO_CONTEXT ||
          this.$store.state.error === ErrorType.NO_COMPANYID ||
          this.$store.state.error === ErrorType.NO_VIN ||
          this.$store.state.error === ErrorType.NO_BASEURL ||
          this.$store.state.error === ErrorType.NO_JWE)
        && !this.isTetheringError;
    },
    isTetheringError: function () {
      return this.$store.state.country === 'KR' && this.$store.state.oneWebNtg === '5.5';
    },
    isMaintenance: function () {
      return this.$store.state.error === ErrorType.MAINTENANCE;
    },
    isNewVehicleError: function () {
      return this.$store.state.error === ErrorType.RETRY_LATER_NEW_VEHICLE
    },
  },
  mounted() {
    // initial error
    this.sentError()
  },
  watch:{
    // when error changes, recheck
    '$store.state.error': function () {
      this.sentError()
    },
  },
  methods: {
    sentError() {
      console.log('got error', this.$store.state.error)
      if (this.$store.state.error === ErrorType.NO_VIN ||
          this.$store.state.error === ErrorType.RETRY_LATER_UI ||
          this.$store.state.error === ErrorType.NO_JWE ||
          this.$store.state.error === ErrorType.NO_CONTEXT ||
          this.$store.state.error === ErrorType.NO_COMPANYID)  {
        axios.post(`/mapupdate/api/v1/uierror`,
            "ERROR from UI is " + this.$store.state.error
            + "\n detailed info: \n" + this.$store.state.errorDescription
            + "\n user Agent: \n" + this.$store.state.analyticsData.userAgent
            ,
            {
              headers: {
                'Content-Type': 'text/plain'
              },
              params:{
                errorType: this.$store.state.error
              },
              validateStatus: () => true,
            })
            .then(() => {
              console.log("ui error send: ", this.$store.state.error);
            })
            .catch((error) => {
              console.error("ui error: ", this.$store.state.error, ", could not be sent because: ",error, ", detailed info: ", JSON.stringify(this.$store.state.analyticsData));
            })
      }
    }
  }
});
</script>
<style lang="scss" src="./ErrorPage.scss"></style>
